import { lazy } from 'react';

export const orgDashboardModalComponentByType = {
  SHARE_NEW_LISTING: lazy(() =>
    import('./ShareNewListing/ShareNewListingModal').then((module) => ({
      default: module.ShareNewListingModal,
    })),
  ),
  DELETE_LISTING: lazy(() =>
    import('./DeleteListing/OrgDashboardDeleteListingModalContainer').then(
      (module) => ({ default: module.OrgDashboardDeleteListingModalContainer }),
    ),
  ),
  DELETE_ORG: lazy(() =>
    import('./DeleteOrg/DeleteOrgModalContainer').then((module) => ({
      default: module.DeleteOrgModalContainer,
    })),
  ),
  ADD_ADMIN: lazy(() =>
    import('./AddAdmin/AddAdminModalContainer').then((module) => ({
      default: module.AddAdminModalContainer,
    })),
  ),
  VAT_NUMBER: lazy(() =>
    import('./VatNumber/VatNumberModalContainer').then((module) => ({
      default: module.VatNumberModalContainer,
    })),
  ),
  HIDE_REPOSTED_LISTINGS: lazy(() =>
    import('./OrgHideRepostedListings/OrgHideRepostedListingsModalContainer').then(
      (module) => ({ default: module.OrgHideRepostedListingsModalContainer }),
    ),
  ),
  CONTACT_CANDIDATE: lazy(() =>
    import('./ContactCandidate/ContactCandidateModal').then((module) => ({
      default: module.ContactCandidateModal,
    })),
  ),
  AUTO_PUBLISH_INTEGRATION: lazy(() =>
    import('./AutoPublishIntegration/AutoPublishIntegrationModalContainer').then(
      (module) => ({ default: module.AutoPublishIntegrationModalContainer }),
    ),
  ),
  DELETE_INTEGRATION: lazy(() =>
    import('./DeleteIntegration/DeleteIntegrationModalContainer').then(
      (module) => ({ default: module.DeleteIntegrationModalContainer }),
    ),
  ),
  CHECKOUT_FEEDBACK: lazy(() =>
    import('./CheckoutFeedback/CheckoutFeedbackModal').then((module) => ({
      default: module.CheckoutFeedbackModal,
    })),
  ),
} as const satisfies Record<string, unknown>;
